import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IossOssComponent} from './tax-reports/components/ioss-oss/ioss-oss.component';
import {ReportsPerStatesComponent} from './tax-reports/components/reports-per-states/reports-per-states.component';
import {IctReportsComponent} from './tax-reports/components/ict-reports/ict-reports.component';
import {TaxReportsComponent} from './tax-reports/tax-reports.component';
import {ReportedTaxReportsComponent} from './reported-tax-reports/reported-tax-reports.component';
import {ReportedTaxReportTabComponent} from './reported-tax-reports/components/reported-tax-report-tab/reported-tax-report-tab.component';
import {TaxReportType} from "../../shared/enums/tax-report-type.enum";

const routes: Routes = [
    {
        path: '',
        redirectTo: 'empact/ioss-oss',
        pathMatch: 'full'
    },
    {
        path: 'empact',
        component: TaxReportsComponent,
        data: {
            accountType: 'empact'
        },
        children: [
            {
                path: 'ioss-oss',
                component: IossOssComponent,
                data: {
                    accountType: 'empact',
                    reportType: 'ioss_oss'
                }
            },
            {
                path: 'rep-per-states',
                component: ReportsPerStatesComponent,
                data: {
                    accountType: 'empact',
                    reportType: 'per_states'
                }
            },
            {
                path: 'ict',
                component: IctReportsComponent,
                data: {
                    accountType: 'empact',
                    reportType: 'ict'
                }
            }
        ]
    },
    {
        path: 'ind',
        component: TaxReportsComponent,
        data: {
            accountType: 'ind'
        },
        children: [
            {
                path: 'ioss-oss',
                component: IossOssComponent,
                data: {
                    accountType: 'ind',
                    reportType: 'ioss_oss'
                }
            },
            {
                path: 'rep-per-states',
                component: ReportsPerStatesComponent,
                data: {
                    accountType: 'ind',
                    reportType: 'per_states'
                }
            }
        ]
    },
    {
        path: 'reported-tax-reports',
        component: ReportedTaxReportsComponent,
        children: [
            {
                path: '',
                redirectTo: 'oss',
                pathMatch: 'full'
            },
            {
                path: 'oss',
                component: ReportedTaxReportTabComponent,
                data: {
                    reportType: TaxReportType.OSS
                }
            },
            {
                path: 'ioss',
                component: ReportedTaxReportTabComponent,
                data: {
                    reportType: TaxReportType.IOSS
                }
            },
            {
                path: 'uk',
                component: ReportedTaxReportTabComponent,
                data: {
                    reportType: TaxReportType.UK
                }
            },
            {
                path: 'regular',
                component: ReportedTaxReportTabComponent,
                data: {
                    reportType: TaxReportType.Regular
                }
            },
            {
                path: 'purchases',
                component: ReportedTaxReportTabComponent,
                data: {
                    reportType: TaxReportType.Purchases
                }
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReportingToolRoutingModule {
}
